export default __webpack_public_path__ + "static/media/405b223d649cad8e9ab97354424c8a131576867181195.d51ae5f7.webp";